import React, { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent } from "@mui/material";

import styles from "./InitiatedDetails.module.scss";
import { Table } from "react-bootstrap";
import axiosClient from "../../service/axios";
import PickRider from "./PickRider";

function InitiatedDetails({ details, setDetails, props }) {
  const [data, setData] = useState([]);

  const [vendor, setVendor] = useState({});
  const [hospital, setHospital] = useState({});

  const [rider, setRider] = useState(false);

  const handleModalClose = () => {
    setDetails(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosClient.get(
          `/lite/v2/api/admin/return/${props?.orderid}/${props?.product}`
        );
        if (response.status === 200) {
          setData(response.data.data);
          setVendor(response.data.vendor);
          setHospital(response.data.hospital);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    if (details && props?.orderid && props?.product) {
      fetchData();
    }
  }, [details, props]);

  const handleSubmit = () => {
    setDetails(false);
    setRider(true);
  };

  const headers = [
    { key: "id", label: "ID" },
    { key: "reason", label: "Reason" },
    { key: "payment", label: "Payment" },
    { key: "channel", label: "Channel" },
    { key: "total", label: "Total" },
    { key: "vendor", label: "Vendor" },
    { key: "hospital", label: "Hospital" },
  ];

  return (
    <>
      <Dialog open={details} onClose={handleModalClose}>
        <DialogContent style={{ paddingBottom: "0" }}>
          <div className={styles.title}>{props?.product}</div>

          <hr />

          <div className={styles.formContainer}>
            <Table borderless responsive>
              <thead>
                <tr className={styles.TableHeadRow}>
                  {headers.map((row) => (
                    <td key={row.key}>{row.label}</td>
                  ))}
                </tr>
              </thead>
              {data.length > 0 ? (
                <tbody>
                  {data.map((items, index) => (
                    <tr key={index} className={styles.tableBodyRow}>
                      <td style={{ width: "10vw" }}>{items?.order_id}</td>
                      <td style={{ width: "10vw" }}>
                        {items?.return_reason === null
                          ? "N/A"
                          : items?.return_reason}
                      </td>
                      <td style={{ width: "10vw" }}>{items?.payment}</td>
                      <td style={{ width: "10vw" }}>
                        {items?.channel === null ? "N/A" : items?.channel}
                      </td>
                      <td style={{ width: "10vw" }}>
                        {items?.total === null ? "N/A" : items?.total}
                      </td>
                      <td style={{ width: "10vw" }}>{vendor?.name}</td>
                      <td style={{ width: "10vw" }}>{hospital?.name}</td>
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="d-flex justify-content-center align-items-center">
                  <tr>
                    <td colSpan={6}>No data found</td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
        </DialogContent>

        <DialogActions style={{ paddingRight: "49px", paddingBottom: "49px" }}>
          <div
            style={{
              cursor: "pointer",
              color: "#ffffff",
              backgroundColor: "#b70303",
              padding: "10px",
              borderRadius: "3px",
              border: "1px solid #DFE1E6",
              fontSize: "14px",
            }}
            onClick={handleSubmit}
          >
            Proceed
          </div>
        </DialogActions>
      </Dialog>

      <PickRider
        rider={rider}
        setRider={setRider}
        id={props?.orderid}
        title={props?.product}
        values={data}
      />
    </>
  );
}

export default InitiatedDetails;
